import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import PropTypes from "prop-types";
import paymentLinkService from "../../../services/PaymentLinkService";
import {
  showErrorAlert,
  handleSuccess,
} from "../../../services/ErrorHandlingService";

const SendPaymentLinkButton = ({
  patientId,
  appointmentId = null,
  leadId = null,
  prescriptionId = null,
  queueId = null,
  paymentFor = "Patient Queue", // "Patient Queue", "Appointment", "Medicine"
  patientName = "",
  amount = "",
  paymentType = "appointment", // "appointment", "receptionist", "counsellor" - kept for future use
  className = "",
  size = "sm",
  variant = "outline-primary",
  disabled = false,
  onSuccess = null,
  onError = null,
  style = {},
  email = "", // Add email prop
}) => {
  const [loading, setLoading] = useState(false);

  // Generate unique payment link ID (same as test payment)
  const generatePaymentLinkId = () => {
    // Create a unique payment link ID that includes patient ID and other relevant IDs
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substr(2, 9);

    // Create a base64 encoded string with all the necessary IDs and calculated amount
    const paymentData = {
      patientId: patientId,
      appointmentId: appointmentId,
      leadId: leadId,
      prescriptionId: prescriptionId,
      queueId: queueId,
      paymentFor: paymentFor,
      paymentType: paymentType,
      patientName: patientName, // Include patient name
      email: email, // Include email
      amount: parseFloat(amount) || 0, // Include the calculated amount from the module
      timestamp: timestamp,
      random: randomString,
    };

    const encodedData = btoa(JSON.stringify(paymentData));
    return encodedData;
  };

  const handleSendPaymentLink = async () => {
    console.log("SendPaymentLinkButton clicked with props:", {
      patientId,
      appointmentId,
      leadId,
      prescriptionId,
      queueId,
      paymentFor,
      patientName,
      amount,
    });

    // if (!patientId) {
    //   showErrorAlert("Patient ID is required");
    //   return;
    // }

    setLoading(true);

    try {
      // Generate unique payment link ID
      const paymentLinkId = generatePaymentLinkId();
      const paymentLinkUrl = `${window.location.origin}/pay/link/${paymentLinkId}`;

      // Prepare payment link data according to your exact payload format
      const paymentLinkData = {
        patient_id: patientId,
        payment_link: paymentLinkUrl,
        lead_id: leadId || null,
        appointment_id: appointmentId || null,
        payment_for: paymentFor,
        prescription_id: prescriptionId || null,
        queue_id: queueId || null,
        email: email, // Add email to the payload
        // Additional data for backend processing
        // customerName: patientName,
        // customerPhone: "9876543210", // This should come from patient data
        // customerEmail: "patient@example.com", // This should come from patient data
        // amount: parseFloat(amount) || 0,
        // description: `Payment for ${paymentFor} - ${patientName}`,
        // paymentType: paymentType,
        // createdBy: localStorage.getItem("user_name") || "Staff",
        // notes: `Payment link for ${paymentFor} - Patient: ${patientName}`,
      };

      console.log("Calling sendPaymentLink API with data:", paymentLinkData);

      // Call backend API to send payment link
      const result = await paymentLinkService.sendPaymentLink(paymentLinkData);

      console.log("API response:", result);

      if (result.success) {
        // Show success message without modal
        handleSuccess("Payment link sent successfully!");

        // Redirect to new tab with the payment link URL
        // window.open(paymentLinkUrl, "_blank");

        // Call success callback if provided
        if (onSuccess) {
          onSuccess(result.data);
        }
      } else {
        showErrorAlert(result.error || "Failed to send payment link");

        // Call error callback if provided
        if (onError) {
          onError(result.error);
        }
      }
    } catch (error) {
      console.error("Error sending payment link:", error);
      showErrorAlert("Failed to send payment link. Please try again.");

      // Call error callback if provided
      if (onError) {
        onError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const getButtonText = () => {
    if (loading) {
      return (
        <>
          <Spinner animation="border" size="md" className="me-2" />
          Sending...
        </>
      );
    }
    return "Send Payment Link";
  };

  console.log("SendPaymentLinkButton rendering with props:", {
    patientId,
    disabled,
    loading,
    variant,
    size,
    className,
  });

  return (
    // <Button
    //   variant={variant}
    //   size={size}
    //   className={className}
    //   // style={style}
    //   style={{
    //     background: "#007680",       // match Collect Payment color
    //     border: "none",
    //     padding: "6px 20px",         // 👈 same vertical + horizontal padding
    //     fontSize: "25px",            // 👈 same font size
    //     fontWeight: "500",           // optional to match Collect Payment
    //     borderRadius: "6px",         // 👈 ensures rounded corners match
    //     minHeight: "51.8px",           // 👈 fixes height to be consistent
    //     ...style,                    // keep any custom overrides
    //   }}
    //   onClick={(e) => {
    //     console.log("Button clicked!");
    //     e.preventDefault();
    //     handleSendPaymentLink();
    //   }}
    //   disabled={disabled || loading}
    //   title="Send payment link to patient"
    // >
    //   {getButtonText()}
    // </Button>
<Button
  type="button"
  className={className}
  style={{
    background: "#17a2b8",      // same as Collect Payment
    border: "none",             // same border
    padding: "6px 20px",        // same padding
    fontSize: "16px",           // same font size
    fontWeight: "500",          // optional (slightly bolder look)
    borderRadius: "6px",        // same rounded corners
    minHeight: "52px",          // ensures same button height
    lineHeight: "1.5",
    color: "white",             // white text
    ...style,                   // allow external overrides
  }}
  onClick={(e) => {
    e.preventDefault();
    handleSendPaymentLink();
  }}
  disabled={disabled || loading}
  title="Send payment link to patient"
>
  {loading ? (
    <>
      <Spinner animation="border" size="sm" className="me-2" />
      Sending...
    </>
  ) : (
    "Send Payment Link"
  )}
</Button>


  );
};

SendPaymentLinkButton.propTypes = {
  patientId: PropTypes.string.isRequired,
  appointmentId: PropTypes.string,
  leadId: PropTypes.string,
  prescriptionId: PropTypes.string,
  queueId: PropTypes.string,
  paymentFor: PropTypes.oneOf(["Patient Queue", "Appointment", "Medicine"]),
  patientName: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paymentType: PropTypes.oneOf(["appointment", "receptionist", "counsellor"]),
  className: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  style: PropTypes.object,
  email: PropTypes.string,
};

export default SendPaymentLinkButton;
